module.exports = __webpack_public_path__ + "img/Group1.b72d38b9.png";